<div class="c-modal c-modal--sm">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p"></div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="rescheduleCloseButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.handleModalClose()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="c-modal__content u-no-pt">
			<div class="c-card c-card--height-fit" style="box-shadow:none;">
				<div class="o-media c-content u-no-p u-osb-sm">
					<p class="c-text">{{ 'Booking.Reschedule_Disclaimer' | translate }}</p>
				</div>
				<form name="vm.form" class="c-form u-ost-xl" novalidate>
					<div class="c-form__group u-osb-lg" [ngClass]="{ 'c-form__group--error': (vm.submitted && (!vm.booking.scheduledStart || vm.error)) }">
						<label for="{{ 'start-' + vm.uid }}" class="c-form__label c-form__label--light c-form__label--required">{{ 'Booking.Choose_Date_And_Time' | translate }}</label>
						<input-datepicker 
							id="{{ 'start-' + vm.uid }}" 
							name="start" 
							[(model)]="vm.scheduleStart" 
							[hasTimepicker]="true" 
							[isSingleDate]="true" 
							[startDate]="vm.booking.scheduledStart" 
							[isRequired]="true">
						</input-datepicker>
						<item-form-error *ngIf="vm.submitted" [fieldName]="'Booking.Date' | translate" [error]="{'required':true}"></item-form-error>
						<ng-container *ngIf="vm.error">
							<div class="u-ost-sm" [ngSwitch]="vm.error">
								<p class="c-text c-text--s3 c-text--sm" *ngSwitchCase="'Booking.Dates.OverlapWithOtherBooking'">{{ 'Booking.Reschedule_Error_Overlap_Booking' | translate }}</p>
								<p class="c-text c-text--s3 c-text--sm" *ngSwitchCase="'Booking.Dates.OverlapWithOtherService'">{{ 'Booking.Reschedule_Error_Overlap_Service' | translate }}</p>
								<p class="c-text c-text--s3 c-text--sm" *ngSwitchCase="'Booking.Invalid.Status'">{{ 'Booking.Reschedule_Error_Invalid_Status' | translate }}</p>
								<p class="c-text c-text--s3 c-text--sm" *ngSwitchDefault>{{ 'Common.Error_Default' | translate }}</p>
							</div>
						</ng-container>
					</div>
				</form>
				<div class="o-grid">
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-p">
						<button id="rescheduleModalSubmitButton" type="button" class="c-button c-button--s1 c-button--fit" (click)="vm.handleFormSubmit()">{{ 'Booking.Reschedule' | translate }}</button>
					</div>
				</div>
				<loader-overlay *ngIf="vm.isProcessing"></loader-overlay>
			</div>
		</div>
	</div>
</div>
